import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=4503dd2a&scoped=true"
import script from "./Site.vue?vue&type=script&lang=js"
export * from "./Site.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503dd2a",
  null
  
)

export default component.exports